import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import home from './home'
import dataReport from './dataReport'
import msgCenter from './msgCenter'
import media from './media'
import advPosition from './advPosition'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,home,media,advPosition,dataReport,msgCenter
  }
})
